import React from 'react';

interface SpreedlyChallengeModalProps {
  showModal: boolean;
}

const SpreedlyChallengeModal: React.FC<SpreedlyChallengeModalProps> = ({
  showModal,
}: SpreedlyChallengeModalProps) => {
  return (
    <>
      <div id="device-fingerprint" className="hidden" />
      <div id="challenge-modal" className={!showModal ? 'hidden' : ''}>
        <div id="challenge" />
      </div>
    </>
  );
};

export default SpreedlyChallengeModal;
